import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Zap,
  Gift,
  RotateCw,
  Shield,
  BarChart3,
  BookOpen,
  Building2,
  Scale,
  Menu,
  X,
} from "lucide-react";

const NAV_ITEMS = [
  { to: "/bonuses/trial", label: "Deneme Bonusu", icon: Zap },
  { to: "/bonuses/no-deposit", label: "Yatırımsız Bonus", icon: Gift },
  { to: "/bonuses/free-spins", label: "Bedava Dönüş", icon: RotateCw },
  { to: "/bonuses/no-wager", label: "Çevrimsiz Bonus", icon: Shield },
  { to: "/comparisons", label: "Karşılaştır", icon: BarChart3 },
  { to: "/brands", label: "Firmalar", icon: Building2 },
  { to: "/guides", label: "Rehberler", icon: BookOpen },
  { to: "/bonus-rules", label: "Bonus Kuralları", icon: Scale },
];

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/60 bg-background/80 backdrop-blur-xl" data-testid="navbar">
      {/* Top bar */}
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-2.5 transition-opacity hover:opacity-80"
          data-testid="navbar-logo"
        >
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary">
            <Zap className="h-5 w-5 text-primary-foreground" />
          </div>
          <span className="text-lg font-bold tracking-tight text-foreground">
            DenemeBonus<span className="text-primary">.ai</span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 lg:flex" data-testid="navbar-desktop-nav">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-primary/10 text-primary"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                }`}
              >
                <Icon className="h-3.5 w-3.5" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Mobile menu button */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="inline-flex items-center justify-center rounded-md p-2 text-muted-foreground hover:bg-muted hover:text-foreground lg:hidden"
          data-testid="navbar-mobile-toggle"
        >
          {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile nav */}
      {mobileOpen && (
        <nav
          className="border-t border-border/60 bg-background px-4 pb-4 pt-2 lg:hidden"
          data-testid="navbar-mobile-nav"
        >
          <div className="grid grid-cols-2 gap-1">
            {NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMobileOpen(false)}
                  className={`flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                    active
                      ? "bg-primary/10 text-primary"
                      : "text-muted-foreground hover:bg-muted hover:text-foreground"
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  {item.label}
                </Link>
              );
            })}
          </div>
        </nav>
      )}
    </header>
  );
}
